import React, { Fragment } from 'react';


import { ReactComponent as MenuIcon } from 'Icons/menu.svg'
import { ReactComponent as SwitchLine } from 'Icons/switch-line.svg'
const RFQSwitchTypeBar = ({ rfqType, switchRfqType }) => {
   return (
      <div className="pr container ht-50 bg-white flex flex-middle">
         <div className="flex flex-middle wt-150 border-right-light mr-30 ht-30">
            <MenuIcon className="mr-10 ht-18 wt-18" />
            <span className="theme-color fs-18 fSemibold">RFQs</span>
         </div>
         {rfqType === 1 && <div className="fBold header-medium-color fs-16 mr-30">Filling A RFQ Form - Single Mode</div>}
         {rfqType === 2 && <div className="fBold header-medium-color fs-16 mr-30">Filling A RFQ Form - Multi Mode</div>}
         {rfqType === 3 && <div className="fBold header-medium-color fs-16 mr-30">Filling A RFQ Form - Dedicated And Fix Mode RFQ</div>}
         {rfqType === 4 && <div className="fBold header-medium-color fs-16 mr-30">Filling A RFQ Form - Courier</div>}
         {rfqType === 5 && <div className="fBold header-medium-color fs-16 mr-30">Filling A RFQ Form - EXIM</div>}
         {(rfqType === 1 || rfqType === 2) && <SwitchLine className="mr-30 curP" onClick={switchRfqType} />}
         {rfqType === 1 && <div className="fBold theme-color fs-16 curP" onClick={switchRfqType}>Switch To Multimodal RFQ Form</div>}
         {rfqType === 2 && <div className="fBold theme-color fs-16 curP" onClick={switchRfqType}>Switch To Single Mode RFQ Form</div>}
      </div>
   );
};

export default RFQSwitchTypeBar;